<template>
  <div>
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <div class="col-lg-2">
          <base-button type="primary" v-on:click="getJobPage()">+ Create Job</base-button>
          &nbsp;
        </div>
        <div class="col-lg-2" style="padding-top: 2px">
          <el-select placeholder="Select service location" v-model="selects.servicelocation" @change="getData()"
            filterable>
            <el-option v-for="option in selects.servicelocations" class="select-info custom-option"
              :value="option.value" :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>

        <div class="col-lg"></div>
        <div class="col-lg-2">

          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search" placeholder="Search Ref No.."
            v-model="searchQuery" aria-controls="datatables"></el-input>

        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div id="tableku" v-if="this.load == false">
              <el-table :data="queriedData" style="width: 100%" height="550" :header-cell-style="{
                background: 'transparent',
                color: 'gray',
              }" class="custom-table">
                <el-table-column :min-width="50" align="center" prop="index" label="NO">
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="jobno" label="REF. NO.">
                  <div slot-scope="{ row }">
                    <p v-if="row.postprocessing == 'Completed'" class="job-no-title" style="color: #358CCB"
                      @click="redirect('view', row.jobno)">
                      {{ row.jobno }}
                    </p>
                    <p v-if="row.postprocessing == 'Ready' ||
                      row.postprocessing == 'In-Progress'
                    " class="job-no-title" style="color: #358CCB" @click="redirect('output', row.jobno)">
                      <!-- @click="redirect('view', row.jobno)" 
                      @click="openoutputpage(row.jobno)"
                    -->

                      {{ row.jobno }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" sortable align="center" prop="datecreated" label="DATE CREATED">
                  <template slot-scope="{row}">
                    {{ moment(row.datecreated).format("DD MMM YYYY") }}
                  </template>
                </el-table-column>
                <el-table-column prop="inputqty" label="INPUT QTY (MT)" align="center" :min-width="200">
                </el-table-column>
                <el-table-column prop="assignedline" label="ASSIGNED LINE" align="center" :min-width="200">
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="jobdurationtime" label="JOB DURATION">
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="postprocessing" label="POST-PROCESSING">
                  <div slot-scope="{ row }">
                    <p style="color: #0baa00" v-if="row.postprocessing == 'Completed'">
                      {{ row.postprocessing }}
                    </p>

                    <p style="color: #ffa827" v-else-if="row.postprocessing.toLowerCase() == 'ready' ||
                      row.postprocessing.toLowerCase() == 'in-progress'
                    ">
                      <!-- @click="openoutputpage(row.jobno)" -->

                      <!-- {{ row.postprocessing }} -->
                      In-Progress
                    </p>
                    <p style="color: #707070" v-else>
                      {{ row.postprocessing }}
                    </p>
                  </div>
                </el-table-column>

                <el-table-column :min-width="200" align="center" prop="wasteoutput" label="WASTE OUTPUT">
                  <div slot-scope="{ row }">
                    <p v-for="(item, index) in row.wasteoutput" :key="index" style="color: #707070">
                      {{ item.wastename }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="outputqty" label="OUTPUT QTY (MT)">
                  <div slot-scope="{ row }">
                    <p v-for="(item, index) in row.wasteoutput" :key="index" style="color: #707070">
                      {{ item.wasteqty }}
                    </p>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </card>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <!-- <base-input> -->
            <el-select v-model="pagination.perPage" placeholder="Per page" style="border-radius: 10px">
              <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>

            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
              :per-page="pagination.perPage" :total="pagination.total"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "src/components"
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";

export default {
  name: "Preprocess",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      selectedFileName: "",
      allfilename: [],
      tableDatas: [
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          inputqty: "300",
          assignedline: "LINE A",
          jobduration: "13H 30M",
          postprocessing: "Completed",
          wasteoutput: "Waste",
          outputqty: "30",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          inputqty: "300",
          assignedline: "LINE A",
          jobduration: "13H 30M",
          postprocessing: "Ready",
          wasteoutput: "Waste",
          outputqty: "30",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          inputqty: "300",
          assignedline: "LINE A",
          jobduration: "13H 30M",
          postprocessing: "-",
          wasteoutput: "Waste",
          outputqty: "30",
        },
      ],

      load: false,

      jobno: [
        {
          prop: "jobno",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "customer",
          label: "CUSTOMER",
        },
        {
          prop: "duedate",
          label: "DUE DATE",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],
        servicelocation: "",
        servicelocations: []
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50],
        total: 0,
      },
    };
  },
  methods: {
    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };
            this.selects.servicelocations.push(obj);
          }
        }
      });
    },
    redirect(flag, refno) {
      if (flag == "create") {
        this.$router.push("/JobPage1/create/" + refno + "/edit");
      }

      if (flag == "view") {
        // this.$router.push("/JobPage1/view/" + refno + "/add");
        this.$router.push("/JobPage1/view/" + refno + "/add");
      }

      if (flag == "output") {
        // this.$router.push("/JobPage1/view/" + refno + "/add");
        this.$router.push("/JobPage1/output/" + refno + "/add");
      }
    },
    secondsToString(hours) {
      var seconds = hours * 60 * 60;

      var numdays = Math.floor(seconds / 86400);

      var numhours = Math.floor((seconds % 86400) / 3600);

      var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);

      var numseconds = ((seconds % 86400) % 3600) % 60;

      return (
        numdays + " days " + numhours + " hours "
        // numminutes +
        // " minutes " +
        // numseconds +
        // " seconds"
      );
    },
    openoutputpage(refno) {
      console.log("open output page");
      this.$router.push("/JobPage1/output/" + refno + "/add");
    },
    getJobPage() {
      // get reference number
      this.$http
        .get(":10001/api/v1/preprocessing/get-reference-number")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.$router.push(
              "/JobPage1/create/" + response.reference_number + "/add"
            );
          }
        });
    },

    getData() {

      this.tableDatas = [];
      this.temp = [];

      this.$http
        .get(
          ":10001/api/v1/preprocessing?search=" +
          this.searchQuery +
          "&page_size=" +
          this.pagination.perPage +
          "&page=" +
          this.pagination.currentPage +
          "&service_location_id=" +
          this.selects.servicelocation

        )
        .then((res) => {
          if (!res.error) {
            console.log(res.message)
            this.pagination.total = res.message.paginate.total_item

            let response = res.message.item;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              // get waste output
              let wasteoutputs = [];
              for (var j = 0; j < response[i].waste_output.length; j++) {
                let obj2 = {
                  wasteqty: response[i].waste_output[j].quantity,
                  wastename: response[i].waste_output[j].name,
                };

                wasteoutputs.push(obj2);
              }
              let obj = {
                index: (i + 1) + (this.pagination.perPage * (this.pagination.currentPage - 1)),
                jobno: response[i].ref_no,
                datecreated: response[i].date_created,
                inputqty: response[i].input_quantity,
                assignedline: response[i].assigned_line,
                jobduration: response[i].duration_hour,
                postprocessing: response[i].status_text,
                wasteoutput: wasteoutputs,
                jobdurationtime: this.secondsToString(
                  response[i].duration_hour
                ),
              };

              this.tableDatas.push(obj);
              this.temp.push(obj);
            }


          }
        });

      // var obj = {
      //   jobno: "hi",
      //   customer: "hello",
      // };

      // this.tableDatas.push(obj);
    },
  },
  created() {
    this.getServiceLocation()
    this.getData();
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    // to() {
    //   let highBound = this.from + this.pagination.perPage;
    //   if (this.total < highBound) {
    //     highBound = this.total;
    //   }
    //   return highBound;
    // },
    // from() {
    //   return this.pagination.perPage * (this.pagination.currentPage - 1);
    // },
    // total() {
    //   return this.searchedData.length > 0
    //     ? this.searchedData.length
    //     : this.tableDatas.length;
    // },
  },
  watch: {
    searchQuery: debounce(function (search) {
      this.getData();
      // console.log(search);
      // if (search != "") {
      //   this.tableDatas = this.temp.filter((value) =>
      //     value.jobno.toLowerCase().includes(search.toLowerCase())
      //   );
      // } else {
      //   this.tableDatas = this.temp;
      // }
    }, 500),
    "pagination.currentPage"() {
      this.getData();
    },
    "pagination.perPage"() {
      this.getData();
    },
    "pagination.total"() {
      console.log(this.pagination)
      console.log("pagination : ", this.pagination.total)
    }
  },
  mounted() {
    // this.fuseSearch = new Fuse(this.tableDatas, {
    //   keys: ["jobno"],
    //   threshold: 1.0,
    // });
  },
};
</script>
<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}
</style>
